const awsExports = {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-west-2:c0be9f46-894d-4615-87fb-2c5944e8079c',
    // REQUIRED - Amazon Cognito Region
    region: 'us-west-2',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-west-2_SeAoRh0mF',
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: '4plfqlbaovdgkq1r6de1b39fij',
  },
  API: {
    endpoints: [
      // {
      //   name: 'RestApi',
      //   endpoint: ' https://ntzw0k9qla.execute-api.us-west-2.amazonaws.com/dev/',
      //   service: 'lambda',
      //   region: 'us-west-2',
      // },
      {
        name: 'OcrApi',
        endpoint: 'https://flps8vvo1j.execute-api.us-west-2.amazonaws.com/dev',
        service: 'lambda',
        region: 'us-west-2',
      },
    ],
  },
  // Storage: {
  //   bucket: 'wiziqcontenttest4', // REQUIRED -  Amazon S3 bucket
  //   region: 'us-west-2', // OPTIONAL -  Amazon service region
  //   identityPoolId: 'us-west-2:19d79464-7ddc-494f-a129-2883fbc8f043',
  //   level: 'public',
  // },
};
export default awsExports;



// WEBPACK FOOTER //
// ./aws_exports.js